export type Language = "pt" | "en" | "es";

export const translations = {
  pt: {
    // Login / Cadastro
    osForCompany: "O sistema operacional do seu negócio.",
    workspaceTitle: "Bold Workspace",
    signInWorkspace: "Entrar no Workspace",
    signUpWorkspace: "Criar Nova Conta",
    fillInfoRegister: "Preencha seus dados para criar sua conta no Bold Workspace.",
    enterEmailPass: "Insira seu e-mail e senha cadastrados para acessar sua conta corporativa.",
    fullName: "Nome Completo",
    corpEmail: "E-mail",
    companyName: "Nome da Empresa",
    accessPassword: "Senha",
    forgotPassword: "Esqueceu a senha?",
    accessAccount: "Acessar Conta",
    registerCompany: "Criar Conta",
    fillAllFields: "Por favor, preencha todos os campos obrigatórios.",
    localDevEnv: "Ambiente de Desenvolvimento Local",
    fillTestCreds: "Preencher Credenciais de Teste",
    dontHaveAccount: "Não tem uma conta?",
    registerCompanyBtn: "Cadastre-se",
    alreadyHaveAccount: "Já possui uma conta?",
    accessHere: "Acesse aqui",
    securityCode2fa: "Código de Segurança (2FA)",
    enter2faCode: "Insira o código de verificação em duas etapas gerado pelo seu aplicativo (como Google Authenticator).",
    sixDigitCode: "Código de 6 Dígitos",
    confirmAccess: "Confirmar Acesso",
    backToLogin: "Voltar para o Login",
    verifying: "Verificando...",
    creatingAccount: "Criando Conta...",
    authenticating: "Autenticando...",

    // Top Bar & Geral
    currentTimeZone: "Fuso horário",
    weatherDefault: "Feira de Santana, 18°C",
    searchPlaceholder: "Pesquisar...",
    notificationsTitle: "Central de Notificações",
    noNotifications: "Nenhuma notificação recente",
    clearAll: "Limpar tudo",
    systemNotification: "Notificação do Sistema",
    settingsTitle: "Configurações",
    appStoreTitle: "Loja de Aplicativos",
    myProfileTitle: "Meu Perfil",
    logoutTitle: "Sair do Sistema",
    switchAccountTitle: "Trocar de Empresa",
    searchAccount: "Pesquisar empresa...",
    activeAccountLabel: "Ativo",

    // Categorias de Configurações
    settingsCategoryPersonal: "Pessoal",
    settingsCategoryCorporate: "Corporativo",
    settingsCategoryCustomization: "Customização",
    settingsTabProfile: "Meu Perfil",
    settingsTabCompany: "Empresa",
    settingsTabSecurity: "Segurança",
    settingsTabWorkspaces: "Workspaces",
    settingsTabApps: "Apps",
    settingsTabWidgets: "Widgets",
    settingsTabDock: "Personalizações",
    settingsTabDeveloper: "Desenvolvedor",
    settingsTabUsers: "Usuários & Perfis",
    settingsTabHistory: "Registros",

    // Configurações - Perfil
    profileSubtitle: "Gerencie suas informações de perfil pessoal no Bold Workspace.",
    profileCardTitle: "Dados do Perfil",
    profileCardDesc: "Atualize seu nome completo e foto de exibição.",
    profileNameLabel: "Seu Nome",
    profileAvatarLabel: "URL da Imagem do Avatar",
    saveProfileBtn: "Salvar Perfil",
    saving: "Salvando...",

    // Configurações - Empresa
    companySubtitle: "Ajustes da conta corporativa e identificadores.",
    companyCardTitle: "Dados Corporativos",
    companyNameLabel: "Razão Social / Nome Fantasia",
    saveCompanyBtn: "Salvar Alterações",

    // Configurações - Segurança
    securitySubtitle: "Gerencie suas credenciais de acesso e segurança multifator.",
    securityCardPassword: "Alterar Senha",
    securityCardMfa: "Autenticação em Duas Etapas (2FA)",
    currentPassword: "Senha Atual",
    newPassword: "Nova Senha",
    confirmNewPassword: "Confirmar Nova Senha",
    changePasswordBtn: "Alterar Senha",
    enable2faBtn: "Ativar 2FA",
    disable2faBtn: "Desativar 2FA",

    // Configurações - Usuários & Perfis
    usersSubtitle: "Gerencie os membros da sua empresa e crie perfis de acesso personalizados por aplicativo.",
    usersTabMembers: "Membros da Equipe",
    usersTabCustomRoles: "Perfis de Apps",
    inviteMemberBtn: "Convidar Membro",
    memberNameLabel: "Nome do Usuário",
    memberEmailLabel: "E-mail do Usuário",
    memberRoleLabel: "Papel na Empresa",
    memberRoleAdmin: "Administrador / Gestor",
    memberRoleOperator: "Operador",
    memberRoleMember: "Membro padrão",
    inviteSuccess: "Usuário convidado com sucesso!",
    inviteError: "Erro ao convidar usuário.",
    createNewRoleBtn: "Criar Novo Perfil",
    roleNameLabel: "Nome do Perfil",
    roleScopesLabel: "Permissões (Escopos)",
    assignedUsersLabel: "Usuários Atribuídos",
    selectAppLabel: "Selecione o Aplicativo",
    roleCreateError: "Erro ao criar perfil de acesso.",
    roleCreateSuccess: "Perfil de acesso criado!",
    roleUpdateSuccess: "Perfil de acesso atualizado!",
    roleDeleteSuccess: "Perfil de acesso excluído!",
    roleAssignSuccess: "Perfil atribuído ao usuário!",
    roleUnassignSuccess: "Perfil removido do usuário!",

    // Clock Widget / Top Bar Popovers
    clockPopoverTitle: "Relógio e Alarmes",
    clockTabAlarms: "Alarmes",
    clockTabTimers: "Temporizador",
    addAlarm: "Adicionar Alarme",
    alarmLabel: "Etiqueta do Alarme",
    timerDuration: "Duração",
    startTimer: "Iniciar",
    pauseTimer: "Pausar",
    resetTimer: "Reiniciar",
    alarmTriggered: "Alarme Disparado!",
    timerTriggered: "Temporizador Concluído!",
    noAlarms: "Nenhum alarme configurado",
    alarmAdded: "Alarme adicionado!",
    alarmDeleted: "Alarme removido!",
    alarmTime: "Hora",
    darkModeLabel: "Modo Escuro",
    languageLabel: "Idioma",
    showTopBarTab: "Barra Superior",
    showDockTab: "Barra de Tarefas (Dock)",
    createProfileTitle: "Criar Novo Perfil",
    accessCheckbox: "Acessar",
    createCheckbox: "Criar",
    readCheckbox: "Ler",
    updateCheckbox: "Atualizar",
    deleteCheckbox: "Deletar",
    noProfiles: "Nenhum perfil de acesso criado.",
    noMarketplaceApps: "Nenhum aplicativo disponível no marketplace.",
    installBtn: "Instalar",
    uninstallBtn: "Desinstalar",
    searchAppPlaceholder: "Pesquisar aplicativo...",
    marketplaceTitle: "Marketplace da Bold",
    topBarCustomization: "Personalização da Top Bar",
    showClockLabel: "Exibir Relógio",
    showDateLabel: "Exibir Data",
    showWeatherLabel: "Exibir Clima",
    timeFormatLabel: "Formato de Hora",
    dateFormatLabel: "Formato de Data",
    dateFormatLong: "Longo (quinta-feira, 25 de junho)",
    dateFormatShort: "Curto (25/06/2026)",

    // Apps & Dock
    emptyWorkspace: "Seu Workspace está limpo.",
    dragAppNotice: "Arraste aplicativos aqui para começar a trabalhar de forma eficiente.",
    openAppsCount: "aplicativos abertos",
    pinnedTabs: "Abas Fixadas",
    otherTabs: "Outras Abas",
    accessProfileHeader: "Perfil de Acesso",

    // Home Hub / Portal Central
    centralPortal: "Hub Inicial",
    greetingMorning: "Bom dia",
    greetingAfternoon: "Boa tarde",
    greetingEvening: "Boa noite",
    homeHeroTitle: "Seu Hub de Produtividade e Empresas",
    homeHeroSubtitle: "Acesse seus ambientes de trabalho corporativos, gerencie múltiplos workspaces e personalize seu perfil.",
    myCompanies: "Minhas Empresas",
    myCompaniesSubtitle: "Selecione uma organização para abrir seu desktop e ferramentas.",
    searchCompany: "Buscar empresa...",
    noCompaniesFound: "Nenhuma empresa encontrada",
    noCompaniesFoundDesc: "Nenhuma organização corresponde ao termo pesquisado",
    clearSearch: "Limpar pesquisa",
    workspacesLabel: "Workspaces:",
    roleOwner: "Proprietário",
    roleAdmin: "Administrador",
    roleManager: "Gerente",
    roleMember: "Membro",
    noCompaniesLinked: "Você ainda não possui nenhuma Empresa vinculada",
    noCompaniesLinkedDesc: "Para ter acesso a workspaces, aplicativos e recursos do Bold Workspace, crie a sua primeira organização ou solicite um convite de acesso.",
    createCompanyBtn: "Criar Nova Empresa",
    waitingInviteText: "Aguardando convite? Peça ao administrador para convidar seu email:",
    myAccount: "Minha Conta",
    createCompany: "Criar Nova Empresa",
    lightModeLabel: "Modo Claro",
    toggleModeLabel: "Alternar Modo",
    accessDisabledToast: "Seu acesso a esta empresa está desativado.",
    connectionErrorData: "Erro de conexão ao carregar seus dados.",
    fillAllPasswordFields: "Preencha todos os campos de senha.",
    passwordsDontMatch: "As novas senhas não coincidem.",
    passwordMinLength: "A nova senha deve ter pelo menos 8 caracteres.",
    passwordChangedSuccess: "Senha alterada com sucesso!",
    profileUpdated: "Perfil atualizado!",
    profileUpdatedDesc: "Seus dados pessoais foram salvos com sucesso.",
    profileSaveError: "Erro ao salvar perfil.",
    profileUpdateError: "Erro ao atualizar perfil",
    twoFactorEnabledSuccess: "Autenticação em 2 Etapas (2FA) ativada com sucesso!",
    twoFactorDisabledSuccess: "Autenticação em 2 Etapas desativada.",
    enterSixDigitCode: "Insira o código de 6 dígitos do autenticador.",
    enter2faOrRecovery: "Insira o código 2FA ou código de recuperação para desativar.",
    twoFactorSetupError: "Erro ao iniciar configuração do 2FA.",
    twoFactorActivateError: "Erro ao ativar 2FA.",
    twoFactorDisableError: "Erro ao desativar 2FA."
  },
  en: {
    // Login / Register
    osForCompany: "The operating system for your business.",
    workspaceTitle: "Bold Workspace",
    signInWorkspace: "Sign in to Workspace",
    signUpWorkspace: "Create New Account",
    fillInfoRegister: "Fill in your details to create your account in Bold Workspace.",
    enterEmailPass: "Enter your registered email and password to access your corporate account.",
    fullName: "Full Name",
    corpEmail: "Email",
    companyName: "Company Name",
    accessPassword: "Password",
    forgotPassword: "Forgot password?",
    accessAccount: "Sign In",
    registerCompany: "Create Account",
    fillAllFields: "Please fill in all required fields.",
    localDevEnv: "Local Development Environment",
    fillTestCreds: "Fill Test Credentials",
    dontHaveAccount: "Don't have an account?",
    registerCompanyBtn: "Sign up",
    alreadyHaveAccount: "Already have an account?",
    accessHere: "Sign in here",
    securityCode2fa: "Security Code (2FA)",
    enter2faCode: "Enter the two-step verification code generated by your app (like Google Authenticator).",
    sixDigitCode: "6-Digit Code",
    confirmAccess: "Confirm Access",
    backToLogin: "Back to Login",
    verifying: "Verifying...",
    creatingAccount: "Creating Account...",
    authenticating: "Authenticating...",

    // Top Bar & General
    currentTimeZone: "Time zone",
    weatherDefault: "Feira de Santana, 18°C",
    searchPlaceholder: "Search...",
    notificationsTitle: "Notification Center",
    noNotifications: "No recent notifications",
    clearAll: "Clear all",
    systemNotification: "System Notification",
    settingsTitle: "Settings",
    appStoreTitle: "App Store",
    myProfileTitle: "My Profile",
    logoutTitle: "Sign Out",
    switchAccountTitle: "Switch Account",
    searchAccount: "Search company...",
    activeAccountLabel: "Active",

    // Settings Categories
    settingsCategoryPersonal: "Personal",
    settingsCategoryCorporate: "Corporate",
    settingsCategoryCustomization: "Customization",
    settingsTabProfile: "My Profile",
    settingsTabCompany: "Company",
    settingsTabSecurity: "Security",
    settingsTabWorkspaces: "Workspaces",
    settingsTabApps: "Apps",
    settingsTabWidgets: "Widgets",
    settingsTabDock: "Customizations",
    settingsTabDeveloper: "Developer",
    settingsTabUsers: "Users & Profiles",
    settingsTabHistory: "Audit Logs",

    // Settings - Profile
    profileSubtitle: "Manage your personal profile information in Bold Workspace.",
    profileCardTitle: "Profile Info",
    profileCardDesc: "Update your full name and display photo.",
    profileNameLabel: "Your Name",
    profileAvatarLabel: "Avatar Image URL",
    saveProfileBtn: "Save Profile",
    saving: "Saving...",

    // Settings - Company
    companySubtitle: "Corporate account settings and identifiers.",
    companyCardTitle: "Corporate Info",
    companyNameLabel: "Company Name / Trade Name",
    saveCompanyBtn: "Save Changes",

    // Settings - Security
    securitySubtitle: "Manage your login credentials and multi-factor security.",
    securityCardPassword: "Change Password",
    securityCardMfa: "Two-Step Verification (2FA)",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    changePasswordBtn: "Change Password",
    enable2faBtn: "Enable 2FA",
    disable2faBtn: "Disable 2FA",

    // Settings - Users & Profiles
    usersSubtitle: "Manage your company members and create custom access profiles per application.",
    usersTabMembers: "Team Members",
    usersTabCustomRoles: "App Profiles",
    inviteMemberBtn: "Invite Member",
    memberNameLabel: "User Name",
    memberEmailLabel: "User Email",
    memberRoleLabel: "Company Role",
    memberRoleAdmin: "Administrator / Manager",
    memberRoleOperator: "Operator",
    memberRoleMember: "Standard Member",
    inviteSuccess: "User successfully invited!",
    inviteError: "Error inviting user.",
    createNewRoleBtn: "Create New Profile",
    roleNameLabel: "Profile Name",
    roleScopesLabel: "Permissions (Scopes)",
    assignedUsersLabel: "Assigned Users",
    selectAppLabel: "Select Application",
    roleCreateError: "Error creating access profile.",
    roleCreateSuccess: "Access profile created!",
    roleUpdateSuccess: "Access profile updated!",
    roleDeleteSuccess: "Access profile deleted!",
    roleAssignSuccess: "Profile assigned to user!",
    roleUnassignSuccess: "Profile removed from user!",

    // Clock Widget / Top Bar Popovers
    clockPopoverTitle: "Clock & Alarms",
    clockTabAlarms: "Alarms",
    clockTabTimers: "Timer",
    addAlarm: "Add Alarm",
    alarmLabel: "Alarm Label",
    timerDuration: "Duration",
    startTimer: "Start",
    pauseTimer: "Pause",
    resetTimer: "Reset",
    alarmTriggered: "Alarm Triggered!",
    timerTriggered: "Timer Completed!",
    noAlarms: "No alarms configured",
    alarmAdded: "Alarm added!",
    alarmDeleted: "Alarm removed!",
    alarmTime: "Time",
    darkModeLabel: "Dark Mode",
    languageLabel: "Language",
    showTopBarTab: "Top Bar",
    showDockTab: "Taskbar (Dock)",
    createProfileTitle: "Create New Profile",
    accessCheckbox: "Access",
    createCheckbox: "Create",
    readCheckbox: "Read",
    updateCheckbox: "Update",
    deleteCheckbox: "Delete",
    noProfiles: "No access profiles created.",
    noMarketplaceApps: "No apps available in the marketplace.",
    installBtn: "Install",
    uninstallBtn: "Uninstall",
    searchAppPlaceholder: "Search application...",
    marketplaceTitle: "Bold Marketplace",
    topBarCustomization: "Top Bar Customization",
    showClockLabel: "Show Clock",
    showDateLabel: "Show Date",
    showWeatherLabel: "Show Weather",
    timeFormatLabel: "Time Format",
    dateFormatLabel: "Date Format",
    dateFormatLong: "Long (Thursday, June 25)",
    dateFormatShort: "Short (06/25/2026)",

    // Apps & Dock
    emptyWorkspace: "Your Workspace is empty.",
    dragAppNotice: "Drag apps here to start working efficiently.",
    openAppsCount: "open applications",
    pinnedTabs: "Pinned Tabs",
    otherTabs: "Other Tabs",
    accessProfileHeader: "Access Profile",

    // Home Hub / Central Portal
    centralPortal: "Central Portal",
    greetingMorning: "Good morning",
    greetingAfternoon: "Good afternoon",
    greetingEvening: "Good evening",
    homeHeroTitle: "Your Productivity & Company Hub",
    homeHeroSubtitle: "Access your corporate workspaces, manage multiple workspaces and customize your profile.",
    myCompanies: "My Companies",
    myCompaniesSubtitle: "Select an organization to open your desktop and tools.",
    searchCompany: "Search company...",
    noCompaniesFound: "No companies found",
    noCompaniesFoundDesc: "No organization matches the search term",
    clearSearch: "Clear search",
    workspacesLabel: "Workspaces:",
    roleOwner: "Owner",
    roleAdmin: "Administrator",
    roleManager: "Manager",
    roleMember: "Member",
    noCompaniesLinked: "You do not have any linked Company yet",
    noCompaniesLinkedDesc: "To access workspaces, apps, and Bold Workspace features, create your first organization or request an access invitation.",
    createCompanyBtn: "Create New Company",
    waitingInviteText: "Waiting for an invitation? Ask the admin to invite your email:",
    myAccount: "My Account",
    createCompany: "Create New Company",
    lightModeLabel: "Light Mode",
    toggleModeLabel: "Toggle Theme",
    accessDisabledToast: "Your access to this company is disabled.",
    connectionErrorData: "Connection error loading your data.",
    fillAllPasswordFields: "Fill in all password fields.",
    passwordsDontMatch: "The new passwords do not match.",
    passwordMinLength: "The new password must be at least 8 characters long.",
    passwordChangedSuccess: "Password successfully changed!",
    profileUpdated: "Profile updated!",
    profileUpdatedDesc: "Your personal data was saved successfully.",
    profileSaveError: "Error saving profile.",
    profileUpdateError: "Error updating profile",
    twoFactorEnabledSuccess: "Two-Step Verification (2FA) successfully enabled!",
    twoFactorDisabledSuccess: "Two-Step Verification disabled.",
    enterSixDigitCode: "Enter the 6-digit authenticator code.",
    enter2faOrRecovery: "Enter 2FA code or recovery code to disable.",
    twoFactorSetupError: "Error initiating 2FA setup.",
    twoFactorActivateError: "Error enabling 2FA.",
    twoFactorDisableError: "Error disabling 2FA."
  },
  es: {
    // Login / Registro
    osForCompany: "El sistema operativo de su negocio.",
    workspaceTitle: "Bold Workspace",
    signInWorkspace: "Iniciar sesión en el Workspace",
    signUpWorkspace: "Crear Nueva Cuenta",
    fillInfoRegister: "Complete sus datos para crear su cuenta en Bold Workspace.",
    enterEmailPass: "Ingrese su correo electrónico y contraseña registrados para acceder a su cuenta corporativa.",
    fullName: "Nombre Completo",
    corpEmail: "Correo",
    companyName: "Nombre de la Empresa",
    accessPassword: "Contraseña",
    forgotPassword: "¿Olvidaste tu contraseña?",
    accessAccount: "Acceder a la Cuenta",
    registerCompany: "Crear Cuenta",
    fillAllFields: "Por favor, complete todos los campos obligatorios.",
    localDevEnv: "Entorno de Desarrollo Local",
    fillTestCreds: "Completar Credenciales de Prueba",
    dontHaveAccount: "¿No tienes una cuenta?",
    registerCompanyBtn: "Regístrate",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
    accessHere: "Accede aquí",
    securityCode2fa: "Código de Seguridad (2FA)",
    enter2faCode: "Ingrese el código de verificación en dos pasos generado por su aplicación (como Google Authenticator).",
    sixDigitCode: "Código de 6 Dígitos",
    confirmAccess: "Confirmar Acceso",
    backToLogin: "Volver al Login",
    verifying: "Verificando...",
    creatingAccount: "Creando Cuenta...",
    authenticating: "Autenticando...",

    // Top Bar & General
    currentTimeZone: "Zona horaria",
    weatherDefault: "Feira de Santana, 18°C",
    searchPlaceholder: "Buscar...",
    notificationsTitle: "Centro de Notificaciones",
    noNotifications: "No hay notificaciones recientes",
    clearAll: "Limpar todo",
    systemNotification: "Notificación del Sistema",
    settingsTitle: "Configuraciones",
    appStoreTitle: "Tienda de Aplicaciones",
    myProfileTitle: "Mi Perfil",
    logoutTitle: "Cerrar Sesión",
    switchAccountTitle: "Cambiar de Cuenta",
    searchAccount: "Buscar empresa...",
    activeAccountLabel: "Activo",

    // Settings Categories
    settingsCategoryPersonal: "Personal",
    settingsCategoryCorporate: "Corporativo",
    settingsCategoryCustomization: "Personalización",
    settingsTabProfile: "Mi Perfil",
    settingsTabCompany: "Empresa",
    settingsTabSecurity: "Seguridad",
    settingsTabWorkspaces: "Workspaces",
    settingsTabApps: "Apps",
    settingsTabWidgets: "Widgets",
    settingsTabDock: "Personalizaciones",
    settingsTabDeveloper: "Desarrollador",
    settingsTabUsers: "Usuarios y Perfiles",
    settingsTabHistory: "Registros",

    // Settings - Profile
    profileSubtitle: "Gestione su información de perfil personal en Bold Workspace.",
    profileCardTitle: "Datos del Perfil",
    profileCardDesc: "Actualice su nombre completo y foto de perfil.",
    profileNameLabel: "Su Nombre",
    profileAvatarLabel: "URL de la Imagen de Avatar",
    saveProfileBtn: "Guardar Perfil",
    saving: "Guardando...",

    // Settings - Company
    companySubtitle: "Ajustes de la cuenta corporativa e identificadores.",
    companyCardTitle: "Datos Corporativos",
    companyNameLabel: "Nombre de la Empresa",
    saveCompanyBtn: "Guardar Cambios",

    // Settings - Security
    securitySubtitle: "Gestione sus credenciales de acceso y seguridad multifactor.",
    securityCardPassword: "Cambiar Contraseña",
    securityCardMfa: "Autenticación en Dos Pasos (2FA)",
    currentPassword: "Contraseña Actual",
    newPassword: "Nueva Contraseña",
    confirmNewPassword: "Confirmar Nueva Contraseña",
    changePasswordBtn: "Cambiar Contraseña",
    enable2faBtn: "Activar 2FA",
    disable2faBtn: "Desactivar 2FA",

    // Settings - Users & Profiles
    usersSubtitle: "Gestione los miembros de su empresa y cree perfiles de acceso personalizados por aplicación.",
    usersTabMembers: "Miembros del Equipo",
    usersTabCustomRoles: "Perfiles de Apps",
    inviteMemberBtn: "Invitar Miembro",
    memberNameLabel: "Nombre del Usuario",
    memberEmailLabel: "Correo del Usuario",
    memberRoleLabel: "Rol en la Empresa",
    memberRoleAdmin: "Administrador / Gestor",
    memberRoleOperator: "Operador",
    memberRoleMember: "Miembro estándar",
    inviteSuccess: "¡Usuario invitado con éxito!",
    inviteError: "Error al invitar al usuario.",
    createNewRoleBtn: "Crear Nuevo Perfil",
    roleNameLabel: "Nombre del Perfil",
    roleScopesLabel: "Permisos (Ámbitos)",
    assignedUsersLabel: "Usuarios Asignados",
    selectAppLabel: "Seleccione la Aplicación",
    roleCreateError: "Error al crear el perfil de acceso.",
    roleCreateSuccess: "¡Perfil de acceso creado!",
    roleUpdateSuccess: "¡Perfil de acceso actualizado!",
    roleDeleteSuccess: "¡Perfil de acceso eliminado!",
    roleAssignSuccess: "¡Perfil asignado al usuario!",
    roleUnassignSuccess: "¡Perfil de acceso removido!",

    // Clock Widget / Top Bar Popovers
    clockPopoverTitle: "Reloj y Alarmas",
    clockTabAlarms: "Alarmas",
    clockTabTimers: "Temporizador",
    addAlarm: "Añadir Alarme",
    alarmLabel: "Etiqueta del Alarme",
    timerDuration: "Duración",
    startTimer: "Iniciar",
    pauseTimer: "Pausar",
    resetTimer: "Reiniciar",
    alarmTriggered: "¡Alarma Disparada!",
    timerTriggered: "¡Temporizador Completado!",
    noAlarms: "Ninguna alarma configurada",
    alarmAdded: "¡Alarma añadida!",
    alarmDeleted: "¡Alarma eliminada!",
    alarmTime: "Hora",
    darkModeLabel: "Modo Oscuro",
    languageLabel: "Idioma",
    showTopBarTab: "Barra Superior",
    showDockTab: "Barra de Tareas (Dock)",
    createProfileTitle: "Crear Nuevo Perfil",
    accessCheckbox: "Acceder",
    createCheckbox: "Crear",
    readCheckbox: "Leer",
    updateCheckbox: "Actualizar",
    deleteCheckbox: "Eliminar",
    noProfiles: "Ningún perfil de acceso creado.",
    noMarketplaceApps: "Ningún aplicativo disponible en el marketplace.",
    installBtn: "Instalar",
    uninstallBtn: "Desinstalar",
    searchAppPlaceholder: "Buscar aplicación...",
    marketplaceTitle: "Marketplace de Bold",
    topBarCustomization: "Personalización de la Top Bar",
    showClockLabel: "Mostrar Relógio",
    showDateLabel: "Mostrar Fecha",
    showWeatherLabel: "Mostrar Clima",
    timeFormatLabel: "Formato de Hora",
    dateFormatLabel: "Formato de Fecha",
    dateFormatLong: "Largo (jueves, 25 de junio)",
    dateFormatShort: "Corto (25/06/2026)",

    // Apps & Dock
    emptyWorkspace: "Su Workspace está vacío.",
    dragAppNotice: "Arrastre aplicaciones aquí para comenzar a trabajar de forma eficiente.",
    openAppsCount: "aplicaciones abiertas",
    pinnedTabs: "Abas Fijadas",
    otherTabs: "Otras Abas",
    accessProfileHeader: "Perfil de Acceso",

    // Home Hub / Portal Central
    centralPortal: "Portal Central",
    greetingMorning: "Buenos días",
    greetingAfternoon: "Buenas tardes",
    greetingEvening: "Buenas noches",
    homeHeroTitle: "Su Hub de Productividad y Empresas",
    homeHeroSubtitle: "Acceda a sus entornos de trabajo corporativos, gestione múltiples workspaces y personalice su perfil.",
    myCompanies: "Mis Empresas",
    myCompaniesSubtitle: "Seleccione una organización para abrir su desktop y herramientas.",
    searchCompany: "Buscar empresa...",
    noCompaniesFound: "Ninguna empresa encontrada",
    noCompaniesFoundDesc: "Ninguna organización coincide con el término de búsqueda",
    clearSearch: "Limpiar búsqueda",
    workspacesLabel: "Workspaces:",
    roleOwner: "Propietario",
    roleAdmin: "Administrador",
    roleManager: "Gerente",
    roleMember: "Miembro",
    noCompaniesLinked: "Aún no tienes ninguna Empresa vinculada",
    noCompaniesLinkedDesc: "Para tener acceso a workspaces, aplicaciones y recursos de Bold Workspace, crea tu primera organización o solicita una invitación de acceso.",
    createCompanyBtn: "Crear Nueva Empresa",
    waitingInviteText: "¿Esperando una invitación? Pídele al administrador que invite a tu correo:",
    myAccount: "Mi Cuenta",
    createCompany: "Crear Nueva Empresa",
    lightModeLabel: "Modo Claro",
    toggleModeLabel: "Alternar Modo",
    accessDisabledToast: "Su acceso a esta empresa está deshabilitado.",
    connectionErrorData: "Error de conexión al cargar sus datos.",
    fillAllPasswordFields: "Complete todos los campos de contraseña.",
    passwordsDontMatch: "Las nuevas contraseñas no coinciden.",
    passwordMinLength: "La nueva contraseña debe tener al menos 8 caracteres.",
    passwordChangedSuccess: "¡Contraseña cambiada con éxito!",
    profileUpdated: "¡Perfil actualizado!",
    profileUpdatedDesc: "Sus datos personales fueron guardados con éxito.",
    profileSaveError: "Error al guardar perfil.",
    profileUpdateError: "Error al actualizar perfil",
    twoFactorEnabledSuccess: "¡Autenticación en 2 Pasos (2FA) activada con éxito!",
    twoFactorDisabledSuccess: "Autenticación en 2 Pasos desactivada.",
    enterSixDigitCode: "Ingrese el código de 6 dígitos del autenticador.",
    enter2faOrRecovery: "Ingrese el código 2FA o código de recuperación para desactivar.",
    twoFactorSetupError: "Error al iniciar configuración de 2FA.",
    twoFactorActivateError: "Error al activar 2FA.",
    twoFactorDisableError: "Error al desactivar 2FA."
  }
};
